import React, {useState, useContext} from "react";

const AccordionContext = React.createContext();

function Accordion({ children, isCurrentOpen }) {

  const [current, setCurrent] = useState( null );

  return (
    <AccordionContext.Provider value={{ current, setCurrent, isCurrentOpen }}>
      { children }
    </AccordionContext.Provider>
  );
}

Accordion.defaultProps = {
  isCurrentOpen: (x, y) => x === y
}

function useAccordionContext() {
  const context = useContext(AccordionContext);

  if (!context) {
    throw new Error(
      `Toggle compound components cannot be rendered outside the Accordion component`,
    )
  }

  return context;
}


function Expanded({data, children})
{
  const {current, isCurrentOpen} = useAccordionContext();
  const expanded = isCurrentOpen( data, current );
  return expanded ? children : null;
}

function Collapsed({data, children})
{
  const {current, isCurrentOpen} = useAccordionContext();
  const expanded = isCurrentOpen( data, current);
  return expanded ? null : children;
}

function SetCurrent({data, children})
{
  const {setCurrent} = useAccordionContext();
  return (
    <div onClick={ () => setCurrent(data) }>
      {children}
    </div>
  )
}

Accordion.Expanded = Expanded
Accordion.Collapsed = Collapsed
Accordion.SetCurrent = SetCurrent

export default Accordion;
